import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import globals from '../globals'
import SubNavigation from '../modules/SubNavigation'
import DataSource from '../DataSource'
import { EXETEL_URL, SERVICE_HOME_SECURE } from '../constants'
import AjaxLoader from '../components/AjaxLoader'
import ServiceHeading from '../modules/ServiceHeading'
import ThreatsBlocked from '../modules/ThreatsBlocked'
import AboutHomeSecure from '../modules/AboutHomeSecure'
import ParentalControl from '../modules/ParentalControl'
import SafeSearch from '../modules/SafeSearch'
import AllowBlockWebsites from '../modules/AllowBlockWebsites'
import ThreatProtection from '../modules/ThreatProtection'
import HomeSecureNotifications from '../modules/HomeSecureNotifications'
import HomeSecureDetailsAndDocs from '../modules/HomeSecureDetailsAndDocs'
import HomeSecureManageSubscription from '../modules/HomeSecureManageSubscription'
import CustomLink from '../components/CustomLink'
import HomeSecureLogOld from '../modules/HomeSecureLog'

class HomeSecureService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            hasErrors: false,
            serviceId: parseInt(this.props.match.params.id),
            serviceDetails: {}
        }

        this.type = SERVICE_HOME_SECURE
    }

    componentDidMount () {
        DataSource.getData(`/api/getService/homeSecure/${this.state.serviceId}`, result => {
            this.setState({
                serviceDetails: result,
                isLoaded: true
            })
            globals.animatePageIn(this.container)
        }, () => {
            this.setState({ isLoaded: true, hasErrors: true })
        })
    }

    getSubNav () {
	    return [
            { title: 'Threats blocked', url: '' },
            { title: 'Activity log', url: '/log' },
            { title: 'Parental control', url: '/parental-control' },
            { title: 'Allow/Block websites', url: '/allow-block-sites' },
            { title: 'Threat protection', url: '/threat-protection' },
            { title: 'Safe search', url: '/safe-search' },
            { title: 'Notifications & privacy', url: '/notifications-privacy' },
            { title: 'Service details & documents', url: '/service-details' },
            { title: 'Cancel Home Secure', url: '/manage-subscription' }
        ]
    }

    updateServiceDetails (data) {
	    this.setState({
            serviceDetails: { ...this.state.serviceDetails, ...data }
        })
    }

    render () {
	    const RenderThreatsBlocked = () => {
	        return (
    <ThreatsBlocked
                    serviceId={this.state.serviceId}
                    totalThreatCount={this.state.serviceDetails.totalThreatCount}
                />
            )
        }

        const RenderParentalControl = () => {
            return (
                <ParentalControl
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    updateServiceDetails={this.updateServiceDetails.bind(this)}
                />
            )
        }

        const RenderSafeSearch = () => {
            return (
                <SafeSearch
                    serviceId={this.state.serviceId}
                    isEnabled={this.state.serviceDetails.safeSearchEnabled}
                    updateServiceDetails={this.updateServiceDetails.bind(this)}
                />
            )
        }

        const RenderAllowBlockSites = () => {
            return (
                <AllowBlockWebsites
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    updateServiceDetails={this.updateServiceDetails.bind(this)}
                />
            )
        }

        const RenderThreatProtection = () => {
            return (
                <ThreatProtection
                    serviceId={this.state.serviceId}
                    isEnabled={this.state.serviceDetails.threatProtectionEnabled}
                    updateServiceDetails={this.updateServiceDetails.bind(this)}
                />
            )
        }

        const RenderNotificationsAndPrivacy = () => {
            return (
                <HomeSecureNotifications
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderServiceDetails = () => {
		    return (
    <HomeSecureDetailsAndDocs
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderManageSubscription = () => {
            return (
                <HomeSecureManageSubscription
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderHomeSecureLog = () => {
            return (
                <HomeSecureLogOld
                    serviceId={this.state.serviceId}
                />
            )
        }

        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        if (this.state.hasErrors) {
            return <Redirect push to='/' />
        }

        const medText = () => {
            if (this.state.serviceDetails.isTrial && !this.state.serviceDetails.isSubscribed) {
                return <span className='bold'>FREE TRIAL ENDS {this.state.serviceDetails.subscriptionEnds}</span>
            }

            if (this.state.serviceDetails.isCancelled) {
                return <span className='color-red'>Cancelled on {this.state.serviceDetails.subscriptionEnds}</span>
            }

            return <CustomLink to={`${EXETEL_URL}/broadband/nbn/home-secure`} className='color-grey gtm-hs-dashboard-what-is-this underline'>Learn more</CustomLink>
        }

        const TrialCopy = (
            <div className='col-12 col-lg-6 d-flex align-items-center justify-content-end  flex-column flex-lg-row mt-3 mt-lg-0'>
                <div className='mr-lg-3 mb-3 mb-lg-0 text-center text-lg-left'>
                    <p className='m-0 mb-1 font-smaller sub-bold color-lime' dangerouslySetInnerHTML={{ __html: globals.noWidows('Early-bird offer - get an extra month free') }} />
                    <p className='m-0' style={{ fontSize: '13px', lineHeight: '18px' }}>
                        Subscribe to <span className='bold'>Home Secure</span> before this free trial ends, and we’ll extend your free trial for an extra month. Home Secure is just <span className='bold'>$6/mth</span> thereafter. No lock-in.
                        &nbsp;<CustomLink to={`${EXETEL_URL}/broadband/nbn/home-secure`} className='color-lime gtm-hs-dashboard-what-is-this underline'>Learn more</CustomLink>
                    </p>
                </div>
                <CustomLink to={`/subscribe-home-secure/${this.state.serviceId}`} className='text-nowrap btn btn-custom'>Subscribe now</CustomLink>
            </div>
        )

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <SubNavigation
                    title='Manage my service'
                    items={this.getSubNav()}
                    url={this.props.match.url}
                    className='gtm-service-manage-tab-click flex-basis-20'
                    mobileSubCopy='(click the arrow on the right to personalise your settings, view reports and manage notifications) '
                />

                <Switch>
                    <Route exact path={this.props.match.url} render={RenderThreatsBlocked} />
                    <Route exact path={`${this.props.match.url}/about`} component={AboutHomeSecure} />
                    <Route exact path={`${this.props.match.url}/parental-control`} render={RenderParentalControl} />
                    <Route exact path={`${this.props.match.url}/safe-search`} render={RenderSafeSearch} />
                    <Route exact path={`${this.props.match.url}/allow-block-sites`} render={RenderAllowBlockSites} />
                    <Route exact path={`${this.props.match.url}/threat-protection`} render={RenderThreatProtection} />
                    <Route exact path={`${this.props.match.url}/notifications-privacy`} render={RenderNotificationsAndPrivacy} />
                    <Route exact path={`${this.props.match.url}/service-details`} render={RenderServiceDetails} />
                    <Route exact path={`${this.props.match.url}/manage-subscription`} render={RenderManageSubscription} />
                    <Route exact path={`${this.props.match.url}/log`} render={RenderHomeSecureLog} />
                </Switch>
            </div>
        )
    }
}

export default withRouter(HomeSecureService)



// WEBPACK FOOTER //
// ./resources/js/services/HomeSecureService.js